import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  Spinner,
  Image,
  Loading,
  Button,
  DataTable,
  ButtonGroup,
  Toast,
  Checkbox,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import Pagination from "@mui/material/Pagination";
import { useParams } from "react-router-dom";
import moment from "moment";

const OrdersByDay = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const addEditState = useRef("");
  const perPage = 50;
  const [ts, setTs] = useState("");
  const [availability, setAvailability] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [page, setPage] = useState(1);
  const [pageObject, setPageObject] = useState({
    isLoading: true,
    isSaving: false,
    tableItems: [],
    tableTotalPages: 0,
    isListEmpty: false,
  });
  const handleAddUser = () => {
    navigate("/admin/settings/users-and-permissions/new");
  };
  function handleFiltersQueryChange(queryValue) {
    refBoolPage.current = false;
    setQueryValue(queryValue);
  }
  function handleAvailabilityChange(availability) {
    setAvailability(availability);
  }
  const handleAvailabilityRemove = useCallback(() => setAvailability(""), []);
  const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);
  const handleFiltersClearAll = useCallback(() => {
    handleAvailabilityRemove();
    handleQueryValueRemove();
  }, [handleAvailabilityRemove, handleQueryValueRemove]);

  const filters = [
    {
      key: "availability",
      label: "Filter by",
      filter: (
        <ChoiceList
          title="Filter by"
          titleHidden
          choices={[
            { label: "Client Name", value: "client_name" },
            { label: "Email", value: "client_email" },
            { label: "Phone Number", value: "phone" },
          ]}
          selected={availability || []}
          onChange={handleAvailabilityChange}
        />
      ),
      shortcut: false,
    },
  ];

  const appliedFilters = [];
  if (!isEmpty(availability)) {
    const key = "availability";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, availability),
      onRemove: handleAvailabilityRemove,
    });
  }
  const loadingMarkup = pageObject.isLoading ? <Loading /> : null;
  const emtyState = pageObject.isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <Image src={emptyListImage}></Image>
      </div>
      <div className="mb-3">
        <Text variant="bodyLg" as="p">
          No results found
        </Text>
      </div>
      <br />
    </div>
  ) : (
    pageObject.isLoading && (
      <div className="spinnerContainer">
        <div className="vertical-center">
          <Spinner size="large" />
        </div>
      </div>
    )
  );
  const refBoolPage = useRef(true);
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };

  const handleClickRow = (param) => {
    //  navigate(`/admin/users/${param}`);
    window.open(`/admin/orders/${id}/details/${param}`, "_blank");
  };
  const handleEdit = (param) => {
    //navigate(`/admin/users/${param}/edit`);
    window.open(`/admin/users/${param}/edit`, "_blank");
  };
  const handlePayments = (param) => {
    navigate(`/admin/users/${param}/payments`);
  };
  const [isSaving, setIsSaving] = useState(false);
  const [date, setDate] = useState("");
  const handleChangeDate = (newValue) => {
    setDate(newValue);
  };
  useEffect(() => {
    fetchData();
  }, [ts, availability, queryValue, page, date]);

  async function fetchData() {
    let response = "";
    let responseFeatures = [];

    try {
      response = await axios.get(
        `/orders/${id}?per_page=${perPage}&page=${
          refBoolPage.current ? page : 1
        }${date ? `?date=${date}` : ""}${
          queryValue
            ? `&filter[${
                availability === "" ? "client_name" : availability
              }]=${queryValue}`
            : ""
        }`
      );
      console.log(response.data.order.data);
      setPageObject({
        ...pageObject,
        tableItems: response.data.order.data.map((item, index) => [
          <div
            className="clickableDiv"
            onClick={() =>
              handleClickRow(
                item.shopify_order_id !== null
                  ? item.shopify_order_id
                  : item.order_id
              )
            }
          >
            {item?.id}
          </div>,
          <div
            className="clickableDiv"
            onClick={() =>
              handleClickRow(
                item.shopify_order_id !== null
                  ? item.shopify_order_id
                  : item.order_id
              )
            }
          >
            {item?.client_name ? item?.client_name : "-"}
          </div>,
          <div
            className="clickableDiv"
            onClick={() =>
              handleClickRow(
                item.shopify_order_id !== null
                  ? item.shopify_order_id
                  : item.order_id
              )
            }
          >
            {item?.client_info && item?.client_info?.email
              ? item?.client_info?.email
              : "-"}
          </div>,
          <div
            className="clickableDiv"
            onClick={() =>
              handleClickRow(
                item.shopify_order_id !== null
                  ? item.shopify_order_id
                  : item.order_id
              )
            }
          >
            {item?.client_info && item?.client_info?.phone
              ? item?.client_info?.phone
              : "-"}
          </div>,
          <div
            className="clickableDiv"
            onClick={() =>
              handleClickRow(
                item.shopify_order_id !== null
                  ? item.shopify_order_id
                  : item.order_id
              )
            }
          >
            {item?.client_info?.addresses?.billing_address?.city || "-"}
          </div>,
          <div
            className="clickableDiv"
            onClick={() =>
              handleClickRow(
                item.shopify_order_id !== null
                  ? item.shopify_order_id
                  : item.order_id
              )
            }
          >
            {item?.client_info?.addresses?.billing_address?.country || "-"}
          </div>,
          <div
            className="clickableDiv"
            onClick={() =>
              handleClickRow(
                item.shopify_order_id !== null
                  ? item.shopify_order_id
                  : item.order_id
              )
            }
          >
            {item?.created_at
              ? moment(item?.created_at).format("YYYY-MM-DD HH:mm:ss")
              : "-"}
          </div>,
        ]),
        isLoading: false,
        isListEmpty: !response.data.order.data.length ? true : false,
        tableTotalPages: response.data.order.total,
      });
    } catch (error) {
      console.log(error);
    }

    // if (!featuresList.length)
    //   try {
    //     responseFeatures = await axios.get(`features`);
    //     setFeaturesList(
    //       responseFeatures.data.data.data.map((item, index) => {
    //         return {
    //           label: item.name,
    //           value: item.id,
    //         };
    //       })
    //     );
    //   } catch (error) {
    //     console.log(error);
    //   }
  }

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This user has been successfully verified"
  );

  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const refId = useRef(null);
  const [activeVerify, setActiveVerify] = useState(false);
  const handleChangeModalVerify = useCallback((activeVerify) => {
    setActiveVerify(!activeVerify);
    setIsSaving(false);
  }, []);
  const handleYesVerify = () => {
    setIsSaving(true);
    axios
      .post(`/app/users/${refId.current}/verify`)
      .then((result) => {
        toggleActive();
        setIsSaving(false);
        setActiveVerify(!activeVerify);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  return (
    <Page
      title="Orders"
      fullWidth
      backAction={{
        onAction: () => navigate("/admin/orders"),
      }}
    >
      <Card padding="0">
        {loadingMarkup}
        {/* <FormLayout>
          <TextField
            prefix="Filter by date: "
            value={date}
            onChange={handleChangeDate}
            type="date"
          />
        </FormLayout> */}
        <Filters
          queryValue={queryValue}
          queryPlaceholder="Search..."
          filters={filters}
          appliedFilters={appliedFilters}
          onQueryChange={handleFiltersQueryChange}
          onQueryClear={handleQueryValueRemove}
          onClearAll={handleFiltersClearAll}
        />

        <DataTable
          columnContentTypes={["text", "text", "text", "text"]}
          headings={[
            <Text variant="bodyMd" as="p" fontWeight="medium">
              ID
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Client Name
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Email
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Phone Number
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              City
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Country
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Created at
            </Text>,
          ]}
          rows={pageObject.tableItems}
          verticalAlign="middle"
          increasedTableDensity
          footerContent={
            pageObject.tableItems?.length &&
            `Showing ${pageObject.tableItems.length} of ${pageObject.tableTotalPages} results`
          }
          hasZebraStripingOnData
          // truncate
        />
        {emtyState}
        {Math.ceil(pageObject.tableTotalPages / perPage) >= 2 && (
          <div
            style={{
              paddingTop: "10px",
              textAlign: "center",
              paddingBottom: "10px",
            }}
          >
            <Pagination
              variant="outlined"
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
            />
            {/* <Pagination
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
              size="large"
            /> */}
          </div>
        )}

        <Modal
          open={activeVerify}
          onClose={handleChangeModalVerify}
          title="Verify User"
          primaryAction={{
            content: "Yes",
            onAction: handleYesVerify,
            loading: isSaving,
          }}
          secondaryActions={[
            {
              content: "No",
              loading: isSaving,
              onAction: handleChangeModalVerify,
            },
          ]}
        >
          <Modal.Section>
            <Text>
              <p>Are you sure you want to verify this user?</p>
            </Text>
          </Modal.Section>
        </Modal>
        {toastMarkup}
      </Card>
    </Page>
  );
  function disambiguateLabel(key, value) {
    switch (key) {
      case "taggedWith":
        return `Tagged with ${value}`;
      case "availability":
        return `Filter by ${value}`;
      default:
        return value;
    }
  }
  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
};

export default OrdersByDay;
